import { UsersThree } from "@phosphor-icons/react";
import { useTranslation } from "react-i18next";

import RenderIf from "common/components/RenderIf";
import { Input } from "common/components/ui/Input";
import type { CampaignType } from "common/types";

import ItemContainer from "./ItemContainer";

import type { UseFormRegister } from "react-hook-form";

interface AudienceSizeProps {
  campaignType: CampaignType;
  errorMessage: string;
  isDrip: boolean;
  register: UseFormRegister<{
    name: string;
    size: number;
  }>;
}

export default function AudienceSize({
  campaignType,
  errorMessage,
  isDrip,
  register,
}: AudienceSizeProps) {
  const isDripType = campaignType === "drip";
  const isList = campaignType === "list" || campaignType === "crm";

  const { t } = useTranslation("campaigns", {
    keyPrefix: "audienceSize",
  });

  let audienceLimit = 10000;
  if (campaignType === "search") {
    audienceLimit = 1000;
  } else if (campaignType === "navigator") {
    audienceLimit = 2500;
  }

  return (
    <ItemContainer
      icon={UsersThree}
      title={t(isDripType ? "dripTitle" : "title")}
      description={t(isDripType ? "dripDescription" : "description")}
      isDrip={isDrip}
      infoText={
        isDripType
          ? t("dripInfoText")
          : t("infoText", {
              limit: audienceLimit,
            })
      }
    >
      <RenderIf condition={!isDripType}>
        <Input
          className="max-w-24 max-lg:ml-[50px]"
          id="audienceSize"
          type="number"
          name="audienceSize"
          hasError={!!errorMessage}
          disabled={isList}
          leftComponent={<UsersThree weight="fill" />}
          {...register("size", {
            valueAsNumber: true,
          })}
        />
      </RenderIf>
    </ItemContainer>
  );
}
